export default {
	language: "한국어 공부 해 요.",//韩语
	sanqi: {
		zhoushi: "추세도",
		biaoti: "고유동 시장에서의 암호화 화폐 거래",
		xiangqing: "다년간의 운영 경험을 통해 고객에게 풍부하고 유연하며 안정적이고 안전한 거래 환경을 제공하였다.",
		Global: "전 세계 생태 구조",
		Bank: "은행급 안전",
		Focus: "사용자 환경에 집중",
		Convenient: "편리한 거래",
		project: "전 세계 프로젝트 확장 및 운영 관리 시스템, 많은 국가에 현지 서비스 무역 센터 설치",
		level: "은행급 지갑 시스템, 실시간 금융 리스크 제어와 다차원 인증, 금융 안전팀은 지난 10년 동안 자금 안전에 다중 보장을 제공했다.",
		polish: "세부 사항을 꼼꼼히 다듬어 UI와 상호작용을 한 단계 한 단계 편안하게 함으로써 거래는 일종의 시각적 즐거움이 될 수 있다",
		Android: "언제 어디서나 실시간으로 시장 정보, 글로벌 시장 및 거래를 제어하는 안드로이드, IOS, 웹 3종단 운영 지원",
		Download: "모바일 클라이언트를 다운로드하여 언제 어디서나 자유롭게 거래 가능",
		Palm: "종려나무 거래",
		Trade: "언제 어디서나 거래 가능",
		flow: "이동 체험",
		Smooth: "원활한 조작으로 더욱 즐거운 체험을 할 수 있습니다",
		Real: "실시간 견적",
		time: "실시간 업데이트로 시장 동향 파악",
		Rapid: "급속 충전",
		Experience: "빠른 체험, 원하는 것을 즐겨라",
		Join: "당신의 계약 여행을 시작하세요",
		Please: "Azbit-usa 를 등록하려면 아래 입력란에 휴대폰/이메일을 입력하십시오.",
		enter: "이메일 또는 휴대폰 번호를 입력하십시오.",
		Register: "등기하다",

		regulatory:'규제 라이선스',
		regulatory_info:'Uncleblock은 캐나다의 FINTRAC(캐나다 금융 거래 및 보고서 분석 센터) 및 미국 SEC(미국 증권 거래 위원회)의 감독하에 합법적인 금융 및 통화 서비스 회사입니다. 언클블록은 금융 라이센스를 기반으로 운영되는 각 관할권의 모든 해당 법률 및 규정을 준수합니다. ',
		canada:'캐나다(감독 중)',
		certnum:'규제 인증서 번호',
		dateissue:'발행일',
		veriurl:'캐나다 확인 URL',
		
		white_paper: '백지',
	},
	song: {
		low:'이전 암호를 입력하십시오.',
	    jgsxf:"극속 계약 주문에서 수수료를 공제하다",
	    jgbj:"극속 계약에서 원금을 공제하다",
	    jgks:"빠른 계약 주문, 손실 결산",
	    jgyl:"극속 계약 주문 창고 정리, 이윤 결산.",
	    htcz:"백그라운드 충전",
	    htshcz:"백그라운드 심사 충전",
	    bbhr:"화폐 계좌 이체",
	    bbhc:"화폐 계좌 이체",
	    pccl:"평 창 자금 처리",
	    gmsxf:"팔다",
	    ggsxf:"레버리지 거래 제출, 수수료 공제",
	    ggbzj:"레버리지 거래 제출, 보증금 공제",
	    gbdj:"등기 동결을 제출하다",
	    gbkc:"매입 공제를 제출하다.",
	    gsdj:"등기 동결을 제출하다",
	    gskc:"등기 공제를 제출하다",
	    tbsbjs:"통화 인출 실패, 잠금 잔액 감소",
	    tbsbch:"통화 인출 실패, 잔액 잠금 철회",
	    tbcg:"화폐 인출 성공",
	    gyf:"지렛대 거래, 격야비 받기",
	    gghr:"지렛대 계좌 이체",
	    gghc:"지렛대 계좌 이체",
	    tbdj:"화폐 인출 동결 잔액을 신청하다",
	    tbkc:"잔액 공제 신청",
	    mhxh:"블로킹 박스 소모",
	    mhhq:"블라인드 박스 획득",
	    msxf:"초 계약 주문에서 수수료를 공제하다",
	    mbj:"초 계약 하의 원금 공제",
	    mks:"초 계약 주문, 손실 결산",
	    myl:"초 계약 주문 평 창, 이윤 결산",
	    mhr:"초 계약 계좌 이체",
	    mhc:"초 계약 계좌 이체",
	    sfsczj:"창고를 잠그고 광물을 캐서 사용 가능한 자산을 증가시키다",
	    sfsckc:"창고를 잠그고 광물을 캐서 동결 자산을 공제하다.",
	    sczj:"창고를 잠그고 광산을 파내어 동결 자산을 증가시키다.",
	    sckc:"창고를 잠그고 광산을 파서 사용 가능한 자산을 공제하다",
	    scsy:"창고를 잠그고 광물을 캐면 수익에 사용할 수 있는 자산이 있다.",
	    ahtcz:"백그라운드 충전 비고",
	    xcbx:"극속 계약 주문 창고 정리 결산, 효력 발생 보험 없음, 자금 불변",
		bbjx:"코인 거래: 사용자가 구매를 취소하고 잠금을 해제",
		bbth:"화폐 거래: 사용자가 구매 취소 반환",
		wtcd_t:"위탁 철회, 수수료 반환",
		wtcd_b:"위탁 철회, 보증금 반환",
		bxju_p:"보험 해지",
		bxju_s:"보험 해지",
		bxju_b:"보험 해지",
	},
	iesan: {
		li_a: '당신 은 집중 만 하 세 요. 다른 것 은 우리 에 게 맡 기 세 요.',
		li_b: '자동화 투자 분석 - Azbit-usa 의 잠 금 창고 채굴 에 따라 투자 자의 주요 거래 화폐 가 맞 춤 형 거래 방향 에 대해 고도 로 자율 화 된 계 정 설정 을 할 수 있 습 니 다. 서로 다른 고객 유형 에 따라 자금 회수 비례 열, 보유 비례 열, 그리고 경고 비례 열 을 설정 할 수 있 습 니 다.시장 에서 서로 다른 위험 감당 능력 을 가 진 거래 자 를 전면적으로 배려 하 다.예약 계좌 대출 - 플랫폼 은 잠 금 채굴 예약 대출 화 폐 를 제공 합 니 다. 귀 하 는 계좌 의 디지털 자산 이 예약 한도 의 50% 에 달 하면 신청 하면 플랫폼 융자 대출 화 폐 를 얻 을 수 있 습 니 다.',
		zuidi: '최저 시작 수량',
		b_liord: "블라인드 주문",
		b_zhomg: "블라인드 박스 가 당첨되다.",
		b_xiaohao: "소모 하 다.",
		b_mangheli: "블라인드 선물",
		b_qingsong: "가 벼 운 발굴 초대형 선물",
		b_kaiqi: "블라인드 박스 를 열다",
		b_xuyao: "현재 블라인드 박스 오픈 필요",
		b_dangqian: "현재 잔액",
		b_quxiao: "취소 하 다.",
		b_ok: "확정 하 다.",
		b_cuocang: "창 고 를 잠 그 고 돈 을 벌다.",
		b_dindan: "블라인드 주문",
		b_genduo: "더 불 러 오기",
		b_wabao: "광물 을 캐다",
		b_jiandan: "채굴 이 더 쉬 워 보상 을 쉽게 받 을 수 있 습 니 다.",
		b_cung: "창 고 를 잠 그 고 돈 을 벌다.",
		b_shouyi: "총 수익",
		b_zhiyao: "저당 수량",
		b_qianbao: "지갑 잔액",
		b_goumai: "사다",
		b_zhjuanbi: "창 고 를 잠 그 고 돈 을 벌다.",
		b_num: "예금 수량",
		b_yuji: "총 수익 을 예상 하 다",
		b_jin: "가깝다",
		b_rinianhua: "일 참고 년 화",
		b_suochang: "창고 잠 금 기한",
		b_gtou: "사다",
		b_jilu: "창고 잠 금 기록",
		b_biaohuao: "항목 번호",
		b_bizhong: "화폐 종류",
		b_shuliang: "예금 수량",
		b_jixi: "총이자",
		b_suocang: "창고 잠 금 시간",
		b_shijan: "만기 시간",
		b_zhuangtai: "상태.",
		b_jinxin: "진행 중",
		b_jieshu: "종료 됨",
		b_zhenqui: "정확 한 수량 을 입력 하 세 요",
		b_tian: "하늘.",
		b_mei: "더 이상 없어 요.",
		b_maghe: "블라인드 박스",
		b_wakuang: '창 고 를 잠 그 고 광산 을 파다.',
		levermin: "数が小数より小さい"
	},
	chongbi: {
		zaixian:"온라인 고객 지원",
		fuzhi:"탭 복사",
		huazhuan:"회전",
		bizhong:"화폐",
		keyong:"사용 가능 잔액",
		cong:"부터",
		zhi:"지",
		num:"회전 수량",
		shuru:"회전 개 수 를 입력 하 세 요",
		whatsapp:"whatsapp 계 정 을 입력 하 세 요.",
		youxiang:"메 일 박스",
		superior: "나의 하급 자.",
		tiem: "시간",
		tit: "나의 회원.",
		group: "팀 수.",
		not: "회원 없 음",
		qukuai: "블록 체인 학당",
		fabi: "법정 화폐 거래",
		gonggao: "공지",
		xitong: "시스템 글",
		yonghu: "사용자 지원",
		bangzhu: "도움말 센터.",
		shouyi: "수익 규칙",
		xinwen: "뉴스 센터.",
		xinshou: "초보 도움.",
		jiaoyi: "거래 규칙",
		kuaixun: "속보.",
	},
	// 导航
	header: {
		wakuang: "창고 잠 그 고 광산 캐 기.",
		miaohy: "계약",
		home: "첫 페이지",
		markets: "시세",
		fiat: "법정 화폐 거래",
		c2c: "C2C 거래",
		exchange: "화폐 거래",
		lever: "계약 거래",
		myshop: "내 상가.",
		assets: "내 자산.",
		help: "도움말 센터.",
		login: "로그 인",
		sign: "등록",
		accountSet: "계 정 설정",
		tradeLog: "거래 일지",
		receiveSet: "수금 설정",
		identify: "인증.",
		jchange: "화폐 교환",
		logout: "로그 인 종료",
		themedark: "야간 모드.",
		themeday: "주간 모드.",
	},
	// 登录注册
	lg: {
		login: "로그 인",
		register: "등록",
	},
	// 首页
	home: {
		vol: "24H 량.",
		c01: "세계 최고의 디지털 자산 거래 플랫폼",
		c02: "전 세계 130 개국 이 넘 는 수백 만 명의 사용자 에 게 안전 하고 신뢰 할 수 있 는 디지털 자산 거래 및 자산관리 서 비 스 를 제공 합 니 다",
		c03: "안전 하고 신뢰 할 수 있 습 니 다.",
		c04: "5 년 디지털 자산 금융 서비스 경험",
		c05: "전문 분포 식 구조 와 DDoS 공격 방지 시스템",
		c06: "글로벌 생태 구조",
		c07: "여러 나라 현지 화 거래 서비스 센터 설립",
		c08: "다 중 업무 형 태 를 하나 로 합 친 블록 체인 생태 권 만 들 기",
		c09: "사용자 지상",
		c10: "선행 배상 체 제 를 세우다.",
		c11: "투자 자 보호 기금 설립",
		c12: "언제 어디서나 다 중 플랫폼 단말기 거래",
		c13: "iOS, Android, Windows 여러 플랫폼 을 덮어 쓰 고 모든 업무 기능 을 지원 합 니 다",
		sweep: "스 캔 다운로드.",
		android: "Android",
		pinput: "메 일이 나 핸드폰 번 호 를 입력 하 세 요.",
		atrade: "IE - X 글로벌 사이트 계 정 을 등록 하고 거래 여정 을 시작 합 니 다."
	},
	// 底部
	foo: {
		about: "우리 에 대해 서.",
		support: "사용자 지원",
		contact: "연락 주세요.",
		qq: "고객 지원 QQ",
		email: "메 일 로 연락 주세요.",
	},
	// 行情
	market: {
		exchange: "화폐",
		selfmarket: "선택.",
		allmarket: "모든 시세.",
		symbol: "거래 맞아요.",
		newprice: "최신 가격",
		change: "상승폭",
		highprice: "최고가.",
		lowprice: "최저 가.",
		vol: "24H 량.",
	},
	// 公共交易
	td: {
		purchase: "구 매가",
		transaction: "거래 가",
		service: "수수료",
		profit: "손익",
		buy: "구 매",
		sell: "판매",
		currency: "화폐",
		num: "수량",
		time: "시간",
		limit: "한도액",
		price: "단가",
		method: "지불 방식",
		total: "총액",
		inwant: "입력 욕",
		do: "조작",
		more: "더 불 러 오기",
		nomore: "더 이상 없어 요.",
		nodata: "데이터 없 음",
		trade: "거래",
		buynum: "구 매 수량",
		sellout: "매출",
		buyin: "매입",
		all: "모두",
		allbuy: "전부 매입",
		allsell: "다 팔 아 요.",
		buytotal: "구 매 하고 자 하 는 총액 을 입력 하 세 요",
		selltotal: "판매 하고 자 하 는 총액 을 입력 하 세 요",
		buyallnum: "구 매 하고 자 하 는 수량 을 입력 하 세 요",
		sellallnum: "판매 하고 자 하 는 수량 을 입력 하 세 요",
		tradeTotal: "거래 총액",
		doceil: "초 후 자동 취소",
		place: "주문 하 다",
		waitpay: "지불 대기",
		paycode: "지불 번호",
		finished: "이미 완성 되 었 습 니 다",
		ceiled: "취소 됨",
		payed: "이미 지불",
		nofinish: "미 완성",
		buyer: "바이어",
		seller: "판매자",
		callWay: "연락처.",
		placeTime: "주문 시간.",
		renum: "참조 번호.",
		canceil: "취소",
		confirm: "확인",
		pwd: "거래 비밀 번 호 를 입력 하 세 요",
		coincode: "화폐 단위",
		pcoin: "화폐 단 위 를 선택 하 세 요"
	},
	// 法币交易
	fat: {
		// LegalPayDetail
		orderLog: "주문 기록",
		fatdLog: "법정 통화 거래 기록",
		shoper: "상인",
		faLog: "법정 통화 거래 기록",
		tdType: "거래 유형",
		odStatus: "주문 상태",
		pwaitPay: "구매자 가 지불 할 때 까지 기 다 려 주세요.",
		odFinish: "주문 완료",
		odCeil: "주문 이 취소 되 었 습 니 다",
		odPay: "이미 지불 하 였 으 니 지불 정 보 를 자세히 확인 하 세 요.",
		tdCeil: "거래 취소",
		pCeil: "만약 당신 이 판매자 에 게 돈 을 지불 했다 면 절대 거래 를 취소 하지 마 세 요.",
		paySure: "지불 확인",
		pdopay: "판매자 에 게 지불 하 셨 는 지 확인 하 세 요",
		badClick: "악의 적 으로 클릭 하면 계 정 이 바로 동 결 됩 니 다",
		receivePay: "수금 확인.",
		payReceive: "구매자 가 이미 당신 에 게 돈 을 지불 한 것 을 확인 하 세 요.",
		receivePays: "수금 확인",
		// LegalPay
		payPlease: "돈 내세 요.",
		tdPrice: "거래 단가",
		tdNum: "거래 수량",
		payinfo: "결제 정보",
		banknum: "은행 계좌",
		realName: "실명.",
		shoperZname: "상가 지점",
		shoperNum: "상가 계좌",
		odCeil: "주문 취소",
		imPay: "지불 하 였 습 니 다. 확인 을 누 르 십시오.",
		// LegalSeller
		register_time: "등록 시간",
		odtotal: "집합체.",
		odmonth: "30 일 주문 완료.",
		odfinish: "완성표",
		odrate: "완성 도.",
		submit: "발표",
		phone: "핸드폰.",
		mysell: "내 판매.",
		mybuy: "내 구 매.",
		realAuth: "실명 인증.",
		advAuth: "고급 인증",
		linebuy: "온라인 구 매",
		linesell: "온라인 판매",
		tipPay: "24 시간 내 에 업 체 에 연락 하여 지불 하 세 요. 24 시간 이 넘 으 면 자동 으로 취 소 됩 니 다.",
		notlow: "최저 한도 보다 낮 으 면 안 돼 요.",
		nothigh: "최대 한 도 를 넘 으 면 안 돼 요.",
		notnum: "최대 수량 초과 불가.",
		// LegalShopDetail
		type: "유형",
		status: "상태",
		seeOrder: "주문서 보기",
		withdraw: "철회",
		abnormal: "이상",
		lowershelf: "내리 세 요.",
		protection: "권익 유지 중.",
		apply: "권익 보호 신청",
		psType: "장르 를 선택해 주세요.",
		pselect: "선택 하 세 요.",
		alipay: "알 리 페 이",
		wechat: "위 챗",
		bank: "카드.",
		minNum: "최소 거래 량",
		maxNum: "최대 거래 량",
		wantBuy: "구 매 요청.",
		pnums: "수량 을 입력 하 세 요",
		pmin: "최소 거래 량 을 입력 하 세 요",
		pmax: "최대 거래 량 을 입력 하 세 요",
		pnot: "최대 거래 량 은 최소 거래 량 보다 작 으 면 안 됩 니 다",
		// MyLegalShops
		myshops: "내 가게.",
		name: "이름",
		fiatSub: "소속 법정 화폐",
		shoper_balance: "상가 잔액",
		enterShop: "가게 로 들 어가 세 요.",
		// shop_legal_pay_detail
		payedWait: "이미 지불 하 였 습 니 다. 확인 후 확인 하 기 를 기다 리 겠 습 니 다.",
		yes: "네",
		no: "아니오",
		sd: "잔액 잠 금",
		journal: "잔액 로그",
		business: "상인",
		user: "사용자",
		backdone: "철 회 했 습 니 다.",
		busbalance: "상가 잔액",
		userbalance: "사용자 잔액",
	},
	ctc: {
		ctc: "C2C",
		myRelease: "내 가 발표 한 C2C.",
		myTrade: "내 거래 의 C2C",
		and: "맞아요.",
		balance: "잔액",
		buynum: "매입 량",
		sellnum: "매출 량.",
		bankTransfer: "은행 이체.",
		payim: "본인 이 지불해 야 합 니 다.",
		pbuyNum: "매입 수량 을 입력 하 세 요",
		pprice: "단가 입력 해 주세요.",
		payway: "결제 방법 을 선택 하 세 요",
		psellNum: "판매 수량 을 입력 하 세 요",
		suerePlace: "주문 확인 하 시 겠 어 요?",
		detail: "자세 한 정보",
		payinfo: "결제 정보",
		Payee: "수취인.",
		total: "    총액",
		name: "이름",
		cardnum: "카드번호.",
		receivePay: "수금 확인",
		ceilConfirm: "거래 취소 확인?",
		paySeller: "판매자 에 게 지불 한 것 을 확인 하 세 요. 악의 적 으로 클릭 하면 계 정 이 동 결 됩 니 다.",
		payBuyer: "당신 이 이미 매수 한 지불 정 보 를 확인 하 세 요",
		account: "계 정.",
		sellerPay: "구매자 가 이미 당신 에 게 돈 을 지불 한 것 을 확인 해 주 시 겠 습 니까?",
		payattion: "지불 확인 후 가능 한 한 빨리 판매자 에 게 지불 하 세 요. 악의 적 으로 클릭 하면 계 좌 를 직접 동결 합 니 다",
		log: "c2c 주문 완료",
	},
	// 合约
	lever: {
		purchase: "구 매가",
		Expected: "손익 예상.",
		countdown: "카운트다운.",
		second: "초",
		jiaoyinum: "수량",
		houmaicg: "구 매 성공",
		nowentrust: "현재 의뢰",
		hisentrust: "역사 의뢰",
		lvchi: "계약 보유",
		all: "모두",
		or: "혹은",
		gotrade: "거래 시작.",
		tdrecord: "거래 기록",
		dealed: "거래 가 성사 되 었 습 니 다.",
		notdeal: "미 거래",
		loading: "불 러 오 는 중...",
		entotal: "위탁 총액",
		canuse: "사용 가능",
		std: "시가 거래",
		xtd: "가격 제한 거래",
		pprice: "가격 입력 해 주세요.",
		phand: "구 매 수량 을 입력 하 세 요",
		phandsell: "판매 수량 을 입력 하 세 요",
		pwd: "비밀번호",
		ppwd: "거래 비밀 번 호 를 입력 하 세 요",
		psw: "거래 비밀번호",
		equal: "같다",
		times: "배",
		timed: "배수",
		hand: "손",
		miao: "s",
		miaos: "초 수.",
		hands: "손 수.",
		ptimes: "배 수 를 선택해 주세요.",
		phands: "손 수 를 선택해 주세요.",
		contractVal: "계약 시가",
		bail: "보증금",
		canBail: "사용 가능 한 보증금",
		charge: "거래 서비스요금",
		domore: "매입 (많이)",
		doshort: "매출 (공매)",
		dmore: "많이 해 요.",
		dshort: "헛수고.",
		sureOd: "주문 확인.",
		noless: "손 수 는 낮 으 면 안 돼 요.",
		nomore: "손 은 높 으 면 안 돼 요.",
		tdnum: "거래 량",
		risk: "위험 율",
		allloss: "창고 보유 총 손익",
		onehouse: "원 클릭 으로 창 고 를 평평 하 게 합 니 다.",
		type: "유형",
		entrustPrice: "위탁 가격",
		openPrice: "창고 개설 가격",
		nowPrice: "현재 가격",
		styPrice: "흑자 정지 가격",
		stsPrice: "손실 정지 가격",
		openTime: "창고 개설 시간.",
		closeTime: "창고 정리 시간.",
		rate: "수수료",
		nightFee: "콜 요금.",
		loss: "    손익",
		setloss: "수익 정지 설정",
		expectProfit: "예상 이익",
		expectLoss: "예상 손실",
		allClose: "전부 창고 정리.",
		moreClose: "멀 티 플 렉 스 만.",
		nullClose: "그냥 텅 비 었 어 요.",
		sureClose: "평 창 확인?",
		thanZearo: "설정 한 값 이 0 이상 이 어야 합 니 다",
		listin: "접수 중.",
		tdin: "거래 중",
		closein: "창고 정리 중.",
		closed: "이미 창 고 를 평정 하 였 습 니 다.",
		revoked: "취소 됨",
		revokeOrder: "주문 취소 확인 하 시 겠 습 니까?",
		ping: "평 창",
		revoke: "취소",
		sureping: "창고 정리 하 시 겠 습 니까?",
		thanzone: "설정 한 값 이 0 이상 이 어야 합 니 다",

		profitability: '수익성',
		profit_: '이익',
	},
	// 币币
	cuy: {
		direction: "방향",
		total: "합계",
		price: "가격",
		sell: "팔다",
		buy: "사다",
		allStation: "전역 거래",
		buyPrice: "매입 가",
		buynum: "매입 량",
		sellPrice: "판매 가격",
		sellnum: "매출 량.",
		tdPrice: "거래액",
		or: "혹은",
		tdStart: "거래 시작.",
		pbPrice: "매입 가 입력 해 주세요",
		pbNum: "매입 물 량 을 입력 하 세 요",
		psPrice: "판매 가 입력 해 주세요.",
		psNum: "판 매 량 을 입력 하 세 요.",
		fixPrice: "가격 제한 거래",
		Mtrans: "시가 거래",
		available: "사용 가능",
		revoke: "취소",
		loading: "불 러 오 는 중",
		confirmCancel: "취소 하 시 겠 습 니까?",
		confirm: "확실 해",
		cancel: "취소",
		nomore: "데이터 가 더 없어 요.",
		evelPrice: "평균 거래 가격"
	},
	// 资产
	asset: {
		text1:"충전 주소",
		text2:"충전 주 소 를 입력 해 주세요.",
		text3:"충전 수량",
		text4:"충전 수량 을 입력 하 세 요",
		text5:"충전 정보 제출",
		miao_account: "극속 계약 계좌",
		assets: "자산",
		currency_account: "화폐 계좌",
		lever_account: "계약 계좌",
		fince_account: "법정 화폐 계좌",
		change_account: "거래 계좌",
		assets_hua: "자금 이체",
		all_assets: "총자 산 환산",
		currency: "화폐",
		canuse: "사용 가능",
		frezz: "동결",
		conversion: "환산",
		charging: "충전",
		withdraw: "동전 인출",
		address_bind: "귀속 인출 주소",
		address_withdraw: "화폐 인출 주소 관리",

		record: "기록",
		address_charge: "충전 주소",
		address_width: "동전 인출 주소",
		copy: "복사",
		ercode: "QR 코드",
		reminder: "'훈훈 한 힌트'.",
		notcharge: "비 USDT 자산을 위의 주소로 재충전하지 마십시오. 그렇지 않으면 자산이 검색되지 않습니다.",
		ornone: "그렇지 않 으 면 자산 을 되 찾 을 수 없 을 것 이다.",
		support: "이 어 코 인 충전 은 심 플 send 방법 만 지원 되 며, 다른 방법 (send all) 을 사용 한 충전 은 당분간 입금 이 불가능 하 니 양해 부탁 드린다 고 덧 붙 였 다.",
		minnum: "최소 인출 수량",
		ratenum: "수수료",
		havenum: "입금 수량.",
		from: "    부터",
		to: "지",
		transfer: "회전",
		tfnum: "회전 수량",
		ptfnum: "최저 입력 하 세 요",
		dtfnum: "의 회전 수량",
		canbalance: "사용 가능 잔액",
		sureConfirm: "회전 확인.",
		moneyRecord: "재무 기록",
		pNum: "회전 개 수 를 입력 하 세 요",
		leverUse: "계약 계좌 사용 가능",
		legalUse: "법정 통화 계 정 사용 가능",
		changeUse: "거래 계좌 사용 가능",
		look: "보기",
		chargeRecord: "충전 기록",
		status: "추적 상태",
		noopen: "이 기능 은 아직 오픈 하지 않 았 습 니 다",
		enterAdderses: "동전 인출 주 소 를 입력 하 세 요",
		enterNum: "인출 수량 을 입력 하 세 요",
		lessMin: "입력 한 동전 인출 수량 이 최소 치보다 적 습 니 다",
		tips01: "상기 주소 에 다른 자산 을 충전 하지 마 십시오. 그렇지 않 으 면 자산 을 되 찾 을 수 없습니다.",
		tips02: "충전 은 Simple send 방법 만 지원 합 니 다. 다른 방법 (send all) 을 사용 한 충전 은 당분간 입금 이 불가능 합 니 다. 양해 해 주 십시오.",
		beizhu: "비고",
		pbeizhu: "메모 입력 해 주세요.",
		add: "추가",
		addressList: "주소 목록",
		delete: "삭제",
		norec: "기록 없 음",
		selectCurrency: "화폐 종 류 를 선택 하 세 요.",
		chainType: "체인 타 입"
	},
	// 账户设置
	set: {
		mycode2: "내 인증 코드.",
		copycode2: "인증 코드 복사",
		uaccont: "당신 의 계 정 보안 레벨:",
		strong: "강하 다",
		middle: "중",
		weak: "약 하 다",
		min: "낮다",
		heigh: "높다",
		complete: "더 많은 자 료 를 보완 해 계 정 안전 보장",
		mycode: "내 초대 번호.",
		copycode: "초대 코드 복사",
		bindphone: "핸드폰 바 인 딩.",
		bindemail: "바 인 딩 메 일",
		loginpwd: "로그 인 비밀번호",
		noBind: "귀속 되 지 않 음",
		binds: "귀속",
		bind: "바 인 딩 하 러 가기.",
		binded: "이미 귀속",
		net: "인터넷 계 정 에 도 난 당 할 위험 이 있 으 므 로 계 정 보안 을 위해 정기 적 으로 비밀 번 호 를 변경 하 는 것 을 권장 합 니 다.",
		reset: "수정",
		setPsw: "거래 비밀 번 호 를 설정 하여 거래 안전 을 보장 합 니 다.",
		goSet: "설치 하 러 가기.",
		bindAccount: "귀속 교환 계좌",
		duihuan: "계 정 을 귀속 하여 포인트 교환 을 진행 합 니 다",
		copysuccess: "복사 성공",
		copyfail: "복사 실패",
		recopy: "다시 복사 해 주세요.",
		account: "계 정",
		detail: "자세 한 정보",
		val: "금액",
		forgetPsw: "비밀번호 까 먹 었 어 요.",
		code: "인증번호",
		getCode: "인증번호 가 져 오기",
		setPsw: "비밀번호 설정",
		enterPsw: "비밀번호 입력 해 주세요.",
		pswFalse: "두 번 입력 한 비밀번호 가 일치 하지 않 습 니 다.",
		enterPswagain: "비밀 번 호 를 다시 입력 해 주세요.",
		jsetPsw: "거래 비밀번호 설정",
		jenterPsw: "거래 비밀 번 호 를 입력 하 세 요",
		jenterPswagain: "거래 비밀 번 호 를 다시 입력 해 주세요",
		enterAccount: "계 정 입력 해 주세요.",
		enterCode: "인증번호 입력 해 주세요.",
		accountFalse: "당신 이 입력 한 휴대 전화 나 메 일 계 정 은 규칙 에 부합 되 지 않 습 니 다!",
		second: "초",
		sendCode: "인증번호 보 내기",
		sendsucc: "발송 성공",
		enterPswTwo: "비밀번호 두 번 입력 해 주세요.",
		rest: "나머지.",
		yes: "네",
		no: "아니오",
		yorn: "거래 비밀 번 호 를 설정 하 시 겠 습 니까?",
	},
	// 身份认证
	auth: {
		identity: "인증.",
		name: "이름",
		idcard: "신분증",
		upimg: "증명서 사진 을 올 려 주세요. 첫 번 째 는 정면, 두 번 째 는 뒷면, 세 번 째 는 손 에 증명 서 를 들 고 정면 사진 을 찍 어 주세요.",
		submit: "제출",
		auditing: "심사 중...",
		certified: "인증 되 었 습 니 다!",
		pname: "이름 입력 해 주세요.",
		pidcard: "증명서 번 호 를 입력 하 세 요.",
		pimg: "증명서 사진 올 려 주세요!",
	},
	// 收款方式
	seting: {
		pmethod: "수금 방식.",
		truename: "실명.",
		opening: "계좌 개설 은행 이름",
		bank: "은행 카드번호.",
		alipay: "알 리 페 이 계좌",
		wename: "위 챗 닉네임.",
		wechat: "위 챗 계 정.",
		pname: "실명 입력 해 주세요.",
		popen: "계좌 개설 줄 이름 을 입력 하 세 요",
		pcard: "카드 번 호 를 입력 해 주세요.",
		palipay: "알 리 페 이 계 정 을 입력 하 세 요",
		pwname: "위 챗 닉네임 입력 해 주세요.",
		pwaccount: "위 챗 계 정 입력 해 주세요.",
		pimg1: "위 챗 입금 번호",
		pimg2: "알 리 페 이 수금 번호"
	},
	// 帮助中心
	news: {
		seeall: "모두 보기",
		helpcenter: "도움말 센터.",
		back: "돌아 가기",
		gonggao: "공지"
	},
	//登录
	login: {
		welcome: "로그 인 을 환영 합 니 다",
		phoneLogin: "휴대폰 로그 인.",
		emailLogin: "메 일 로그 인",
		account: "계 정.",
		psw: "비밀번호",
		login: "로그 인",
		nouser: "아직 IE - X 사용자 아니에요?",
		goRegister: "이 어 즉시 등록 해 세계 선두 디지털 자산 거래 플랫폼 에서 거래 를 시작한다 고 덧 붙 였 다.",
		registerFree: "무료 등록",
		psw6: "비밀 번 호 는 여섯 자리 보다 작 으 면 안 돼 요."
	},
	register: {
		register: "등록",
		phoneRegister: "휴대폰 등록.",
		emailRegister: "메 일 등록.",
		country: "    국적",
		enterPhone: "핸드폰 번호 입력 해 주세요.",
		enterEmail: "메 일 입력 해 주세요.",
		psw16: "비밀 번 호 는 6 - 16 자리 사이.",
		inviteCode: "초대장 번호",
		sel: "필수",
		sel2: "필수 아 닙 니 다.",
		read: "나 는 이미 읽 고 동의 했다.",
		xieyi: "사용자 프로 토 콜",
		tips01: "이 어 국적 정 보 는 등록 후 수정 할 수 없 으 니 반드시 사실대로 선택해 달라 고 덧 붙 였 다.",
		tips02: "    이 어 검증 메 일이 스 팸 메 일 로 오 판 될 수 있 으 니 잘 받 아 달라 고 덧 붙 였 다.",
		tips03: "IE - X 계 정 및 로그 인 비밀 번 호 를 잘 저장 하 세 요.",
		tips04: "다른 사이트 와 같은 로그 인 비밀 번 호 를 사용 하지 마 세 요.",
		emailFalse: "입력 한 메 일 은 규칙 에 맞지 않 습 니 다"
	},
	// 积分兑换
	jc: {
		title: "JC 환전 디지털 자산 BEAU 플랫폼",
		balance: "잔액",
		cannum: "사용 가능 한 JC 수량",
		new: "최신 가격",
		exnum: "교환 수량",
		pnum: "JC 수량 입력 해 주세요.",
		canex: "BEAU 수량 으로 교환 가능",
		exnow: "즉시 교환",
		record: "교환 기록",
		exprice: "환전 가격",
		extime: "교환 시간",
		not: "사용 가능 한 포인트 수량 부족",
		usenum: "JC 사용 수량.",
		out: "퇴장",
		gotd: "거래 하 러 가요."

	}

}



// WEBPACK FOOTER //
// ./src/lang/kr.js